"use strict";

module.exports = {
    sentenceLength: {
        recommendedWordCount: 25
    }
};
//# sourceMappingURL=it.js.map
//# sourceMappingURL=it.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/config/content/it.js
// module id = 494
// module chunks = 0